export enum UserStatusTypes {
  Pending = 0,
  Confirmed = 1,
  Locked = 3,
}

export const getUserStatusName = (userStatusId: UserStatusTypes): string => {
  if (userStatusId === UserStatusTypes.Pending) {
    return 'Pending'
  }

  if (userStatusId === UserStatusTypes.Confirmed) {
    return 'Confirmed'
  }

  if (userStatusId === UserStatusTypes.Locked) {
    return 'Locked'
  }

  return '-'
}

export enum UserStatusFilterKey {
  userStatusId = 'UserStatusId ',
}
